import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "list",
  class: "agile__list"
}
const _hoisted_2 = {
  ref: "slidesClonedBefore",
  class: "agile__slides agile__slides--cloned"
}
const _hoisted_3 = {
  ref: "slides",
  class: "agile__slides agile__slides--regular"
}
const _hoisted_4 = {
  ref: "slidesClonedAfter",
  class: "agile__slides agile__slides--cloned"
}
const _hoisted_5 = {
  key: 0,
  class: "agile__caption"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 2,
  ref: "dots",
  class: "agile__dots"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'agile--ssr': _ctx.isSSR, 'agile--auto-play': _ctx.settings.autoplay, 'agile--disabled': _ctx.settings.unagile, 'agile--fade': _ctx.settings.fade && !_ctx.settings.unagile, 'agile--rtl': _ctx.settings.rtl, 'agile--no-nav-buttons': !_ctx.settings.navButtons}, "agile"]),
    onTouchstart: () => {}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        ref: "track",
        style: _normalizeStyle({transform: `translate(${_ctx.translateX + _ctx.marginX}px)`, transition: `transform ${_ctx.settings.timing} ${_ctx.transitionDelay}ms`}),
        class: "agile__track",
        onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMouseOut('track'))),
        onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMouseOver('track')))
      }, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.slidesCloned]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ], 512 /* NEED_PATCH */),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.slidesCloned]
        ])
      ], 36 /* STYLE, NEED_HYDRATION */)
    ], 512 /* NEED_PATCH */),
    (_ctx.$slots.caption)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "caption")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.settings.navButtons && !_ctx.settings.unagile)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          ref: "prevButton",
          disabled: !_ctx.canGoToPrev,
          "aria-label": "Previous",
          class: "agile__nav-button agile__nav-button--prev",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPrev(), _ctx.restartAutoPlay()))
        }, [
          _renderSlot(_ctx.$slots, "prevbutton", {}, () => [
            _cache[6] || (_cache[6] = _createTextVNode(" ← ", -1 /* CACHED */))
          ])
        ], 8 /* PROPS */, _hoisted_6))
      : _createCommentVNode("v-if", true),
    (_ctx.settings.dots && !_ctx.settings.unagile)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countSlides, (n) => {
            return (_openBlock(), _createElementBlock("li", {
              key: n,
              class: _normalizeClass([{'agile__dot--current': n - 1 === _ctx.currentSlide}, "agile__dot"]),
              onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMouseOut('dot'))),
              onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMouseOver('dot')))
            }, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.goTo(n - 1), _ctx.restartAutoPlay())
              }, _toDisplayString(n), 9 /* TEXT, PROPS */, _hoisted_8)
            ], 34 /* CLASS, NEED_HYDRATION */))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    (_ctx.settings.navButtons && !_ctx.settings.unagile)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          ref: "nextButton",
          disabled: !_ctx.canGoToNext,
          "aria-label": "Next",
          class: "agile__nav-button agile__nav-button--next",
          type: "button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToNext(), _ctx.restartAutoPlay()))
        }, [
          _renderSlot(_ctx.$slots, "nextbutton", {}, () => [
            _cache[7] || (_cache[7] = _createTextVNode(" → ", -1 /* CACHED */))
          ])
        ], 8 /* PROPS */, _hoisted_9))
      : _createCommentVNode("v-if", true)
  ], 34 /* CLASS, NEED_HYDRATION */))
}